import gql from 'graphql-tag';

export const ActivityUserFragment = gql`
  fragment ActivityUserFragment on User {
    primaryIdentityId
    displayName
    pictureUrl
    id: primaryIdentityId
    __typename
  }
`;

export const BaseActivityCommentFragment = gql`
  ${ActivityUserFragment}
  fragment BaseActivityCommentFragment on ActivityComment {
    id
    __typename
    text
    createdAt
    user {
      ...ActivityUserFragment
    }
  }
`;

export const BaseActivityLikeFragment = gql`
  ${ActivityUserFragment}
  fragment BaseActivityLikeFragment on ActivityLike {
    id
    __typename
    createdAt
    user {
      ...ActivityUserFragment
    }
  }
`;

export const ActivityReactionFragment = gql`
  ${BaseActivityCommentFragment}
  ${BaseActivityLikeFragment}
  fragment ActivityReactionFragment on ActivityReaction {
    __typename
    id
    comments {
      ...BaseActivityCommentFragment
    }
    likes {
      ...BaseActivityLikeFragment
    }
  }
`;

export const ActivityReactionWithCommentReactionsFragment = gql`
  ${BaseActivityCommentFragment}
  ${BaseActivityLikeFragment}
  ${ActivityReactionFragment}
  fragment ActivityReactionWithCommentReactionsFragment on ActivityReaction {
    __typename
    id
    comments {
      ...BaseActivityCommentFragment
      reactions {
        ...ActivityReactionFragment
      }
    }
    likes {
      ...BaseActivityLikeFragment
    }
  }
`;

export const CommentActivityMutation = gql`
  ${ActivityReactionWithCommentReactionsFragment}
  mutation CommentActivityMutation(
    $activityId: ID!
    $activityType: ActivityType!
    $activityPrimaryIdentityId: ID!
    $eventId: ID!
    $text: String!
  ) {
    commentOnActivity(
      input: {
        activityId: $activityId
        activityType: $activityType
        activityPrimaryIdentityId: $activityPrimaryIdentityId
        eventId: $eventId
        text: $text
      }
    ) {
      ...ActivityReactionWithCommentReactionsFragment
    }
  }
`;

export const LikeActivityMutation = gql`
  ${ActivityReactionWithCommentReactionsFragment}
  mutation LikeActivityMutation(
    $activityId: ID!
    $activityType: ActivityType!
    $activityPrimaryIdentityId: ID!
    $eventId: ID!
  ) {
    reactions: likeActivity(
      input: {
        activityId: $activityId
        activityType: $activityType
        activityPrimaryIdentityId: $activityPrimaryIdentityId
        eventId: $eventId
      }
    ) {
      ...ActivityReactionWithCommentReactionsFragment
    }
  }
`;

export const UnlikeActivityMutation = gql`
  ${ActivityReactionWithCommentReactionsFragment}
  mutation UnlikeActivityMutation(
    $activityId: ID!
    $activityType: ActivityType!
    $activityPrimaryIdentityId: ID!
    $eventId: ID!
  ) {
    reactions: unlikeActivity(
      input: {
        activityId: $activityId
        activityType: $activityType
        activityPrimaryIdentityId: $activityPrimaryIdentityId
        eventId: $eventId
      }
    ) {
      ...ActivityReactionWithCommentReactionsFragment
    }
  }
`;
